'use strict';

class IntroVideoCtrl {
  constructor(slideshow) {
    this.slideshow = slideshow;
  }

  playVideo() {
    this.slideshow.show([
      {
        type: 'video',
        id: 144345301
      }
    ]);
  }
}

IntroVideoCtrl.$inject = [
  'slideshow'
];

export default IntroVideoCtrl;



// WEBPACK FOOTER //
// ./app/src/common/intro_videos/intro_video.js